module.exports = __webpack_public_path__ + "static/media/stack-center.e722f22a.jpg";